import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, companyAccessGuard, noAuthGuard } from './core/guards/auth.guards';
import { AuthLayout } from './layouts/auth/auth.layout';
import { LogoutPage } from './modules/auth/pages/logout/logout.page';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  /* Acceso (sin sesión) */
  {
    path: '',
    component: AuthLayout,
    canActivate: [noAuthGuard],
    loadChildren: () => import('./modules/auth/auth-module').then(m => m.AuthModule),
  },
  { path: 'logout', component: LogoutPage },
  /* Consola del negocio (sidebar). Se conserva el prefijo histórico /dashboard/projects/:idCompany */
  {
    path: 'dashboard/projects/:idCompany',
    canActivate: [authGuard, companyAccessGuard],
    loadChildren: () => import('./modules/company/company-module').then(m => m.CompanyModule),
  },
  /* Nivel cuenta: Negocios (dueño y sudo), Agregar negocio, Mi perfil, Ayuda, catálogos sudo */
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadChildren: () => import('./modules/account/account-module').then(m => m.AccountModule),
  },
  { path: 'catalogues/social-networks', redirectTo: 'dashboard/social-networks' },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
